export default [
    {
        path: '/website-widgets',
        props: true,
        component: () => import('@/views/WebsiteWidget'),
    },
    {
        path: '/website-widgets/:id',
        props: true,
        component: () => import('@/views/WebsiteWidget/Show'),
    },
];
